import { ZeitspanneFilterApiDto } from '@/api-schema';
export class LieferantenDokumentFilterDto {
    constructor() {
        this.suchText = '';
        this.dokumentKategorieCode = '';
        this.offset = 0;
        this.entriesToLoad = 25;
        this.sortOrder = 'Descending';
        this.sortBy = 'createdOn';
    }
    dateFrom?: string; // date-time
    dateTo?: string; // date-time
    zeitspanne?: ZeitspanneFilterApiDto;
    suchText = '';
    dokumentKategorieCode?: string;
    offset: number;
    entriesToLoad?: number;
    sortBy?: string;
    sortOrder?: string;
}
